import AppController from "../app_controller";
import { C_BLOGGER_BLOG } from "../controller_names";

export default class extends AppController {

  // List of controllers instance
  get blog() {
    return this.ctrl(C_BLOGGER_BLOG);
  }
}
